const escapeRegExp = (str = '') => str.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1')

const Highlight = ({ search = '', children = '' }) => {
    const patt = new RegExp(`(${escapeRegExp(search)})`, 'i')
    const parts = String(children).split(patt)

    if (search) {
        return parts.map((part, index) =>
            patt.test(part) ? <span className="font-bold" key={index}>{part}</span> : part
        )
    } else {
        return children
    }
}

export default Highlight
